import React, { useEffect, useState } from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { fetchLatestRecipeCorrectionSummary } from './api';
import { RecipeCorrectionRunSummary } from './types';

interface RecipeCorrectionApprovalBarProps {
  assetId: string;
  onViewChanges: () => void;
}

const RecipeCorrectionApprovalBar: React.FC<RecipeCorrectionApprovalBarProps> = ({
  assetId,
  onViewChanges,
}) => {
  const [run, setRun] = useState<RecipeCorrectionRunSummary | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchLatestRecipeCorrectionSummary(assetId)
      .then((next) => {
        if (!cancelled) setRun(next);
      })
      .catch(() => {
        if (!cancelled) setRun(null);
      });
    return () => {
      cancelled = true;
    };
  }, [assetId]);

  if (!run) return null;

  const when = new Date(run.appliedAt).toLocaleString('sv-SE');

  return (
    <Paper
      elevation={0}
      sx={{
        px: 1.5,
        py: 0.75,
        mb: 1,
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Typography variant="body2" sx={{ fontSize: '0.8rem', color: '#1c2b3a', flex: 1, minWidth: 0 }}>
          Receptändring godkänd av: {run.approvedByName}, {when}
        </Typography>
        <Button
          size="small"
          variant="outlined"
          onClick={onViewChanges}
          sx={{ textTransform: 'none', fontWeight: 700, py: 0.25, flexShrink: 0 }}
        >
          Visa ändringar
        </Button>
      </Box>
    </Paper>
  );
};

export default RecipeCorrectionApprovalBar;
